import {formatDate} from "utils/valueFormatter.function";
import type {DocumentDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";
import {DocumentAmountField} from "./DocumentAmount.component";

/** The fields every document has, for a document whose DTO the panel doesn't know. */
const DocumentDataDefault = ({details, translate}: DocumentDetailsProps) => (
    <DocumentDataGrid>
        {details.description &&
            <DocumentDataField id="description" wide label={translate("documentData.description")}
                               value={details.description}/>}
        <DocumentDataField id="documentId" label={translate("documentData.documentID")} value={details.documentId}/>
        {!!details.invoiceDate &&
            <DocumentDataField id="invoiceDate" label={translate("documentData.invoiceDate")}
                               value={formatDate(details.invoiceDate, null)}/>}
        {details.supplierName &&
            <DocumentDataField id="supplierName" label={translate("documentData.supplierName")}
                               value={details.supplierName}/>}
        {!!details.dueDate &&
            <DocumentDataField id="dueDate" label={translate("documentData.dueDate")}
                               value={formatDate(details.dueDate, null)}/>}
        <DocumentAmountField details={details} translate={translate}/>
    </DocumentDataGrid>
);

export default DocumentDataDefault;
